<template>
  <div class="field img">
    <span v-if="label"
          class="label text-right"
          :class="labelClass"
    >
      {{ label }}
    </span>

    <div class="value"
         :class="valueClass"
    >
      <b-img :src="value"
             :title="title"
             :alt="alt"
             thumbnail
             fluid
      />
    </div>
  </div>
</template>

<script>
import bImg from 'bootstrap-vue/es/components/image/img'

export default {
  components: {
    bImg
  },

  props: {
    value: {
      type: String
    },
    label: String,
    title: String,
    alt: String,
    alone: Boolean
  },

  computed: {
    labelClass () {
      return this.alone ? 'col-2' : 'col-4'
    },

    valueClass () {
      if (this.label) {
        return this.alone ? 'col-10' : 'col-8'
      }
    }
  }
}
</script>
